<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. The Birthplace of Montana:</a></p>
<p class="toc2"><a href="#/Chapter1#C1-1">Fort Benton Commemorates 175 Years</a></p>
<p class="toc1"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. Montana’s First Great Historian:</span></p>
<p class="toc2"><span href="#/Chapter2#C2-1" title="Link target outside of Sample">Gallant Lieutenant James H. Bradley</span></p>
<p class="toc1"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. The Death of a Bold Scheme:</span></p>
<p class="toc2"><span href="#/Chapter3#C3-1" title="Link target outside of Sample">The Ophir Massacre</span></p>
<p class="toc1"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Thrilling Scenes:</span></p>
<p class="toc2"><span href="#/Chapter4#C4-1" title="Link target outside of Sample">The 1865 Fort Benton Treaty Council</span></p>
<p class="toc1"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. A Code of Honor All Her Own:</span></p>
<p class="toc2"><span href="#/Chapter5#C5-1" title="Link target outside of Sample">Madame Dumont</span></p>
<p class="toc1"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. More Than a War Chief of the Piegan Blackfeet:</span></p>
<p class="toc2"><span href="#/Chapter6#C6-1" title="Link target outside of Sample">A Tribute to Little Dog</span></p>
<p class="toc1"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. The Mystery and Bold Legend:</span></p>
<p class="toc2"><span href="#/Chapter7#C7-1" title="Link target outside of Sample">General Thomas Francis Meagher</span></p>
<p class="toc1"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. What a Way to Treat a Lady!:</span></p>
<p class="toc2"><span href="#/Chapter8#C8-1" title="Link target outside of Sample">Libby Meagher’s Rocky Ride Downriver</span></p>
<p class="toc1"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Hidden Stories:</span></p>
<p class="toc2"><span href="#/Chapter9#C9-1" title="Link target outside of Sample">The Vigilantes of Fort Benton</span></p>
<p class="toc1"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Vigilante Hangman X. Beidler:</span></p>
<p class="toc2"><span href="#/Chapter10#C10-1" title="Link target outside of Sample">Fort Benton’s Marshal</span></p>
<p class="toc1"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. The Greatest Social Event:</span></p>
<p class="toc2"><span href="#/Chapter11#C11-1" title="Link target outside of Sample">Opening the Grandest Hotel</span></p>
<p class="toc1"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. Let There Be Light:</span></p>
<p class="toc2"><span href="#/Chapter12#C12-1" title="Link target outside of Sample">The <i>Rose Bud</i> Lights Up the Night</span></p>
<p class="toc1"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. The Montana Years of the Gandhi of the Métis:</span></p>
<p class="toc2"><span href="#/Chapter13#C13-1" title="Link target outside of Sample">Louis Riel in Exile</span></p>
<p class="toc1"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. A Multicultural Melting Pot:</span></p>
<p class="toc2"><span href="#/Chapter14#C14-1" title="Link target outside of Sample">Fort Benton</span></p>
<p class="toc1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?2d9a45a3